export const StandMixerIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
    <path
      d="M22.8718 16.7881H10.0918C10.0918 16.7881 10.0918 16.8227 10.0918 16.8401V18.9318C10.0918 19.5987 10.6332 20.1357 11.2958 20.1357H21.6722C22.3392 20.1357 22.8762 19.5944 22.8762 18.9318V16.8401C22.8762 16.8401 22.8762 16.8054 22.8762 16.7881H22.8718Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3164 20.1357H14.5312V29.4079H18.3164V20.1357Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.23 29.4072H3.12859C2.18449 29.4072 1.41797 30.1738 1.41797 31.1179V34.3269C1.41797 40.6542 6.12981 45.877 12.2361 46.6912H20.1311C26.2331 45.8814 30.9449 40.6542 30.9449 34.3269V31.1179C30.9449 30.1694 30.1784 29.4072 29.2343 29.4072H29.23Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.1185 46.6962H48.8874V16.7881H33.9636V38.6583C33.9636 40.3603 33.4872 42.0406 32.5085 43.4308C32.4435 43.5261 32.3742 43.6213 32.3049 43.7166C30.9234 45.5875 28.7364 46.6962 26.4108 46.6962H4.55358C2.37088 46.6962 0.599609 48.4674 0.599609 50.6501C0.599609 52.8328 2.36655 54.5998 4.54924 54.5998H53.1228C53.9976 54.5998 54.7035 53.8939 54.7035 53.0191V48.2812C54.7035 47.4064 53.9976 46.7005 53.1228 46.7005L53.1185 46.6962Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M53.6591 5.82715H4.49219"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M51.8705 0.599609H6.28079C5.29297 0.599609 4.49219 1.40039 4.49219 2.3882V14.9993C4.49219 15.9871 5.29297 16.7879 6.28079 16.7879H51.8705C52.8583 16.7879 53.6591 15.9871 53.6591 14.9993V2.3882C53.6591 1.40039 52.8583 0.599609 51.8705 0.599609Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
